import React from "react"
import Header from "../components/header"
import Layout from "../components/layout"
import Seo from "../components/seo"
import "./about.css"

const siteName = process.env.GATSBY_siteCompanyName || "Nuestra Tienda"
const siteEmail = process.env.GATSBY_siteEmail || ""

function AboutPage() {
  return (
    <Layout>
      <Seo
        title="Nosotros"
        path="/about"
        description={`Conoce ${siteName}: quiénes somos y cómo comprar.`}
      />
      <Header site="dark-hero" />
      <div className="about-page">
        <div className="about-hero">
          <h1>{siteName}</h1>
          <p className="about-tagline">Calidad y confianza en cada compra</p>
        </div>

        <div className="about-content">
          <section className="about-section">
            <h2>Quienes Somos</h2>
            <p>
              Somos una tienda en linea comprometida con ofrecerte los mejores
              productos con la comodidad de comprar desde donde estes.
              Trabajamos directamente con proveedores de confianza para
              garantizar autenticidad y calidad en cada articulo.
            </p>
          </section>

          <section className="about-section">
            <h2>Nuestro Compromiso</h2>
            <div className="about-values">
              <div className="about-value">
                <h3>Productos Originales</h3>
                <p>
                  Cada producto pasa por un riguroso control de calidad antes de
                  llegar a tus manos.
                </p>
              </div>
              <div className="about-value">
                <h3>Envio Seguro</h3>
                <p>
                  Empaque especializado con rastreo en tiempo real desde nuestra
                  bodega hasta tu puerta.
                </p>
              </div>
              <div className="about-value">
                <h3>Atencion Personalizada</h3>
                <p>
                  Nuestro equipo te ayuda a encontrar exactamente lo que
                  necesitas.
                </p>
              </div>
            </div>
          </section>

          {siteEmail && (
            <section className="about-section about-contact">
              <h2>Contacto</h2>
              <p>
                ¿Tienes preguntas? Escribenos a{" "}
                <a href={`mailto:${siteEmail}`}>{siteEmail}</a>
              </p>
            </section>
          )}
        </div>
      </div>
    </Layout>
  )
}

export default AboutPage
